// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__-5mu7"};